// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__BHYfC","checkboxCol":"Table_checkboxCol__2BOUD","emailCol":"Table_emailCol__3Ty1P","actionCol":"Table_actionCol__12yKt"};